/* eslint-disable */
import Axios from 'axios';
import store from '../store/index';

// 获取用户信息
const userInfo = store.getters.getUserInfo;
// 开发环境的URL
const devURL = '/api';
// 生产环境的URL
const prodUrl = '/';
// 配置请求的根路径 判断是开发环境还是生产环境
Axios.defaults.baseURL = process.env.NODE_ENV === 'development' ? devURL : prodUrl;

// 创建axios实例
const axios = Axios.create({
  timeout: 100000, // 设置网络超时
  responseType: 'json',// 设置响应类型
  withCredentials: true,// 跨域的情况下使用
  headers: { 'Content-Type': 'application/json' },// 后端获取内容的格式
});
// 设置请求拦截器
axios.interceptors.request.use((config) => { // 处理添加请求参数，解除权限问题
  // const token = `wxcf1171fa0ab73709${(new Date()).valueOf()}`; // 拼接token
  const token = `wxcf1171fa0ab737091590482685326`; // 拼接token
  // const expressNumber = `SF1300713620214` // 物流参数
  if (config.method == 'get') {
    config.url += `&token=${token}`;
  } else if (config.method == 'post') {
    if (config.data) {
      config.data.token = token;
    } else {
      config.data = {
        token,
        // expressNumber
      };
    }
    config.data.patient_id = userInfo.patientId;
  }
  return config;
});
export default axios;
